import { isNativeApp } from '../utils/isNativeApp';

export function initNativeApp() {
  if (!isNativeApp()) return;

  // Mantiene lo splash nativo visibile ~3s, poi nasconde.
  // Su web non viene eseguito.
  setTimeout(async () => {
    try {
      const { SplashScreen } = await import('@capacitor/splash-screen');
      await SplashScreen.hide();
    } catch {
      // no-op
    }
  }, 3000);
}
